import * as React from 'react';
import { Catalyst } from '@shapeable/copper-connect-types';

export const CatalystsContext = React.createContext<Catalyst[]>([]);
export const CatalystsProvider = CatalystsContext.Provider;
